import styled from '@emotion/styled';
import {mixinOverflow} from 'webapp-lib/styling';

import Placeholder, {StyledHeader} from '../Placeholder';

/** @deprecated Use EList instead */
export const StyledList = styled.div`
  user-select: none;
  display: grid;
  grid-auto-rows: min-content;
  ${mixinOverflow}

  a {
    text-decoration: none;
    width: 100%;
  }

  > ${Placeholder} {
    height: 100%;
    justify-content: flex-end;
    padding-left: var(--gutter);

    ${StyledHeader} {
      font-size: var(--font-size-default);
      font-weight: var(--font-weight-title);
      text-align: center;
      margin-bottom: var(--gutter);
      margin-top: var(--gutter);
      color: var(--color-core-primary);
    }

    > svg {
      max-width: 100%;
      max-height: 100%;
      height: unset;
    }
  }
`;
